<template>
  <div>
    <div v-if="!!am_class" :class="question.options.hidden ? 'hidden-colors' : ''">
      <div v-if="!hideHeader">
        <b-row>
          <b-col class="col-12 col-md-9">
            <h3>{{ question.type == 'ticket_block' ? question.label : am_class.name }}
              <b-button
                v-if="isMultiClass && !isLive"
                variant="link"
                size="sm"
                style="font-size: 12px;"
                class="shadow-none"
                @click="editClass">
                  <i class="fa fa-fw fa-edit"></i>
              </b-button>
            </h3>
            <p v-if="question.options.subtitle">{{ question.options.subtitle }}</p>
            <div class="small class-admins" style="margin-top: 5px;margin-bottom: 5px;" v-if="question.options.show_staff && am_class.admins && am_class.admins.length > 0">
                <i class="fa fa-fw fa-user"></i>
                <span v-for="(admin, adminIndex) in am_class.admins" :key="adminIndex">{{ admin.first_name }} {{ admin.last_name }}<span v-if="adminIndex !== am_class.admins.length - 1">,</span></span>
            </div>
            <div style="margin-bottom: 5px;" v-if="question.options.show_tags">
              <span class="badge second mr-2" v-for="(tag, tagIndex) in am_class.tags" :key="tagIndex">{{ tag.name }}</span>
            </div>
            <events-schedule
              :organization="organization"
              :cls="am_class"
              :events="amClassEventsForSchedule"
              :schedule="schedule || question.schedule_for_included_dates"
              :hide-times="question.options.hide_times || (isOneDayMultipleTimes && !!purchase_rule) || false"
              :limit-next-events-count="question.options.limit_next_events_count"
              :custom-schedule="customSchedule"
              :show-custom-schedule-on-invoice="question.options.show_custom_schedule_on_invoice"
              :hide-upcoming="question.options.hide_occurrences"
              :hide-schedule="question.options.hide_schedule"
              @upcoming="upcoming = $event"
            ></events-schedule>
          </b-col>
          <b-col class="col-12 col-md-3 text-right">
            <div v-if="showPrice">
              <h3 v-if="!question.options.custom_price">
                <dollar v-if="!isFree" :value="startPrice"></dollar>
                <small v-if="!isFree && showStartingAt" class="d-block" style="font-size: 50%;">{{ trans('starting_at') }}</small>
                <span v-if="isFree">{{ trans('free') }}</span>
              </h3>
              <div v-if="question.options.custom_price" v-html="question.options.custom_price"></div>
              <div v-if="!!question.member_discount_msg">
                <b-badge variant="success" :title="question.member_discount_msg" v-b-tooltip.hover>
                  {{ trans('member_discount') }}
                </b-badge>
              </div>
              <div v-if="proRataReduction > 0 && !hasNoShowRebate" :title="proRataReductionTitle">
                <span style="text-decoration: line-through;">
                  {{ currency(startPriceBeforeReduction) }}
                </span>
                <b-badge variant="success" class="ml-2" style="border-radius: 4px;">
                  {{ numeral(proRataReduction/startPriceBeforeReduction).format('0%') }}
                  {{ trans('discount_off').toLowerCase() }}
                </b-badge>
              </div>
              <div v-if="promoCodeReduction > 0">
                <span style="text-decoration: line-through;">
                  {{ currency(startPriceBeforeReduction) }}
                </span>
                <b-badge variant="success" class="ml-2" style="border-radius: 4px;">
                  <span v-if="promo_code && question.options.display_promo_dollar">
                    {{ currency(promoCodeReduction) }}
                  </span>
                  <span v-else>
                    {{ numeral(promoCodeReduction/startPriceBeforeReduction).format('0%') }}
                  </span>
                  {{ trans('discount_off').toLowerCase() }}
                </b-badge>
              </div>
              <div v-if="!question.options.custom_price && !!am_class && !!am_class.financing && !question.options.disable_installments && !(!!recipientForm && recipientForm.has_schedule_payments)">
                <b-badge variant="success" style="margin-top: 2px;">
                  {{ trans('installments_available') }}
                </b-badge>
              </div>
            </div>
            <h3 v-if="!showPrice">
              &nbsp;
            </h3>
            <small v-if="hasMaximumAttendance && showNumberOfSpots && am_class.spots >= 0" :class="`d-block ${am_class.spots == 0 ? 'text-danger' : ''}`">
              <span>{{ am_class.spots }} {{ trans('remaining_spots').toLowerCase() }}</span>
            </small>
            <small v-if="am_class.location" class="d-block mt-2">
              {{ am_class.location.name }}
            </small>
          </b-col>
        </b-row>
        <description-more v-if="!!am_class.description && !question.options.show_full_desc" class="my-2" :text="am_class.description" :words="100">
          <div v-html="am_class.description"></div>
        </description-more>
        <div v-html="am_class.description" v-if="!!am_class.description && question.options.show_full_desc"></div>
        <div v-if="am_class.location && am_class.location.address" :class="am_class.location.map_image_url && (!question.options || !question.options.show_map) ? 'mb-3' : 'mb-1'">
          <small v-if="!am_class.location.map_url">
            {{ am_class.location.address }}
          </small>
          <a v-if="am_class.location.map_url" class="d-block" :href="am_class.location.map_url" target="_blank">
            <small>{{ am_class.location.address }}</small>
          </a>
        </div>
        <div v-if="am_class.location && am_class.location.map_image_url && question.options && question.options.show_map" class="mb-3">
          <b-img fluid :src="am_class.location.map_image_url" />
        </div>
      </div>
      <div v-if="question.is_membership_required || question.member_discount_msg" class="mt-2">
        <p v-if="question.is_membership_required">
          <span class="text-danger">{{ trans('membership_required') }}.</span>
          <a href="#" @click.prevent>
            {{ trans('connect_to_register') }}
          </a>
        </p>
        <p v-if="question.member_discount_msg && !question.is_membership_required">
          <span class="text-success">{{ trans('member_discount_available') }}.</span>
          <a href="#" @click.prevent>
            {{ trans('connect_to_discount') }}
          </a>
        </p>
      </div>
      <b-alert variant="light" :show="passwordProtected && !passwordUnlocked" style="border-radius:0;">
        <b-row class="new-form">
          <b-col>
            <div class="py-2 text-dark">
              <i class="fa fa-fw fa-lock"></i>
              {{ trans('class_password_protected') }}
            </div>
          </b-col>
          <b-col class="col-auto pt-1">
            <b-button
              variant="branded"
              size="sm"
              @click="$bvToast.show('design-warning')"
            >
              {{ trans('enter_password') }}
            </b-button>
          </b-col>
        </b-row>
      </b-alert>
      <div v-if="registrationPeriodError" class="text-danger">
        {{ registrationPeriodError }}
      </div>
      <div style="position: relative;">
        <div v-if="passwordProtected && !passwordUnlocked" style="position: absolute; left: 0; top: 0; bottom: 0; right: 0; opacity: 0.7; background-color: #fff; z-index: 1000;">&nbsp;</div>
        <input type="hidden" :name="`${question.slug}[am_class_id]`" :value="am_class.id" />
        <input type="hidden" :name="`${question.slug}[events_slug]`" :value="question.options.events_slug" v-if="question.options.events_slug" />
        <div v-if="!!purchase_rule && futureDateOptions.length > 0" class="mt-2">
          <h6 v-if="question.type != 'ticket_block'">
            {{ trans('select_date_'+purchase_rule) }}
            {{ question.required ? '*' : '' }}
          </h6>
          <b-form-group v-if="!showCalendar">
            <div v-if="purchase_rule.indexOf('multiple') === 0 && futureDateOptions.length >= 4" class="mb-1">
              <b-button variant="link" size="sm" class="text-branded p-0 select-all" @click="onSelectOrClearAll(true)">
                {{ trans('select_all') }}
              </b-button>
              <b-button variant="link" size="sm" class="text-branded p-0 ml-2 unselect-all" @click="onSelectOrClearAll(false)">
                {{ trans('unselect_all') }}
              </b-button>
            </div>
            <b-form-checkbox-group
              v-if="purchase_rule.indexOf('multiple') === 0"
              stacked
              v-model="selected"
              :name="`${question.slug}[dates][]`"
              :options="futureDateOptions"
              :disabled="disabled"
              @change="onOneDateChange"
            ></b-form-checkbox-group>
            <b-form-radio-group
              v-if="purchase_rule.indexOf('single') === 0 && futureDateOptions.length <= 4"
              stacked
              v-model="chosen"
              :name="`${question.slug}[dates][]`"
              :options="futureDateOptions"
              :disabled="disabled"
            ></b-form-radio-group>
            <b-form-select
              v-if="purchase_rule.indexOf('single') === 0 && futureDateOptions.length > 4"
              v-model="chosen"
              :name="`${question.slug}[dates][]`"
              :options="futureDateOptions"
              :disabled="disabled"
            ></b-form-select>
            <b-form-radio-group
              v-if="purchase_rule == 'morning_afternoon'"
              stacked
              v-model="morning_afternoon"
              :name="`${question.slug}[dates][]`"
              :options="morningAfternoonOptions"
              :disabled="disabled"
            ></b-form-radio-group>
            <b-button v-if="showClear" variant="link" size="sm" class="px-0 text-muted restart-btn-style" @click="onClickClear">
              {{ trans('clear') }}
            </b-button>
          </b-form-group>
          <div v-if="showCalendar">
            <b-row>
              <b-col>
                <div class="event-calendar-header py-3">
                  <b-button variant="link" class="text-dark px-1 py-0" @click="onClickPrevMonth">
                    <i class="fa fa-fw fa-chevron-left"></i>
                  </b-button>
                  <strong>
                    {{ moment(calendar_date).format('MMMM') }}
                  </strong>
                  <b-button variant="link" class="text-dark px-1 py-0" @click="onClickNextMonth">
                    <i class="fa fa-fw fa-chevron-right"></i>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <full-calendar
              class="event-calendar"
              ref="calendar"
              defaultView="dayGridMonth"
              :defaultDate="calendar_date"
              height="auto"
              :plugins="calendar_plugins"
              :locale="calendar_locale"
              themeSystem="bootstrap"
              :header="false"
              :events="calendarEvents"
              :eventRender="onEventRender"
              resourceOrder="order"
              @eventClick="onEventClick"
              :selectable="false"
            ></full-calendar>
            <b-row class="mb-4">
              <b-col>
                <div v-if="purchase_rule == 'multiple'" class="event-calendar-footer p-2">
                  {{ selected.length }} / {{ futureDateOptions.length }}
                  {{ trans('selected').toLowerCase() }}
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
        <div  @click="registrationOnClick">
        <b-overlay
          :show="is_registering"
          rounded
          opacity="0.5"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-form-group v-if="!purchase_rule && !hideRegButton" :class="`register-btn ${regDisabled ? 'disabled' : ''} ${pre_checked ? 'checked' : ''}`">
            <b-form-checkbox v-model="pre_checked" :disabled="regDisabled" @change="onRegisterChange">
              {{ question.options.purchase_cta || trans(question.type == 'ticket_block' ? 'reserve' : 'register') }}
              {{ question.required ? '*' : '' }}
              <span v-if="showPrice && question.options.price_rule == 'price_per_date' && upcoming.length > 1">
                ({{ upcoming.length }} {{ trans('dates').toLowerCase() }} x <dollar :value="price"></dollar>)
              </span>
            </b-form-checkbox>
          </b-form-group>
          <div class="mb-2" v-if="invoice.status != 'finalized' && !!timer && pre_checked && !timer.expired" :style="`${!purchase_rule && !hideRegButton ? 'display: inline;' : ''}`">
          <small :class="`${timer.expired ? 'text-danger' : ''}`">
            <i class="fa fa-fw fa-check" style="color: #39b254"></i> {{ trans('you_have_x_to_register', {
              time: timer.text
            }) }}
          </small>
        </div>
        </b-overlay>
        <div v-if="pre_checked && !purchase_rule">
          <input type="hidden" :name="`${question.slug}[dates][]`" v-for="event in futureDateOptions" :value="moment(event.start).toISOString()" :key="event.id" />
          <input type="hidden" :name="`${question.slug}[am_class_id]`" :value="am_class.id" />
          <input type="hidden" :name="`${question.slug}[events_slug]`" :value="question.options.events_slug" v-if="question.options.events_slug" />
        </div>
        </div>
        <b-form-group v-if="!!am_class.financing && showPrice && !question.options.disable_installments && !(!!recipientForm && recipientForm.has_schedule_payments)">
          <b-form-checkbox :disabled="registrationPeriodError != null" v-model="financing" v-if="installmentString">
              {{ installmentString }}
          </b-form-checkbox>
        </b-form-group>
        <div class="text-danger mb-3" v-if="!!am_class.financing && showPrice && !question.options.disable_installments && (!!recipientForm && recipientForm.has_schedule_payments)">
          {{ trans('has_scheduled_payment_error') }}
        </div>
        <b-row v-if="showPrice && question.options.accept_coupon">
          <b-col>
            <b-form-group v-if="!show_coupon">
              <b-button variant="link" class="p-0" @click="show_coupon = true">
                {{ trans('add_a_coupon') }}
                <small><i class="fa fa-fw fa-chevron-right"></i></small>
              </b-button>
            </b-form-group>
            <b-form-group v-if="show_coupon" :label="trans('add_a_coupon')" class="w-50">
              <b-form-input v-model="coupon" size="sm" :placeholder="trans('code')" class="text-info" />
            </b-form-group>
          </b-col>
        </b-row>
        <div v-if="question.type == 'event_block' && ((isLive && (pre_checked || selected && selected.length > 0)) || !isLive)">
          <template v-if="show_participant">
            <template v-if="question.options.participant.multiple">
              <h6>{{ question.options.show_participant_label ? question.options.show_participant_label : trans('participants') }}</h6>
              <div v-for="(participant, index) in participants" :key="index">
                <b-button variant="link" size="sm" class="p-0 text-danger float-right" @click="onRemoveParticipant(index)" v-if="index > 0">
                  <i class="fa fa-fw fa-times"></i>
                  {{ trans('remove') }}
                </b-button>
                <div style="clear: both"></div>
                <form-person-question
                  v-model="answers['participants'][index]"
                  :question="participantQuestionWithIndex(index)"
                  :size="size"
                  :is-live="isLive"
                ></form-person-question>
              </div>
              <b-row class="mb-3">
                <b-col>
                  <b-button variant="outline-primary" size="sm" class="py-0 float-right" @click="addParticipant">
                    <i class="fa fa-fw fa-plus"></i>
                    {{ trans('add_participant') }}
                  </b-button>
                </b-col>
              </b-row>
            </template>
            <form-person-question
              v-else
              v-model="answers['participant']"
              :question="participant_question"
              :size="size"
              :is-live="isLive"
            ></form-person-question>
          </template>
          <div v-if="showGuestParticipants">
            <label class="d-block">
              <strong>{{ question.options.guest_participants_label || trans('guest_participants') }}</strong>
            </label>
            <b-row v-for="(item, index) in guest_participants" v-bind:key="index">
              <b-col>
                <b-form-group>
                  <label v-if="index == 0" class="text-muted">
                    <small>{{ trans('item') }}</small>
                  </label>
                  <div class="py-2">{{ item.label }}</div>
                </b-form-group>
              </b-col>
              <b-col class="pr-0">
                <b-form-group>
                  <label v-if="index == 0" class="text-muted">
                    <small>&nbsp;</small>
                  </label>
                  <div>
                    <span>x</span>
                    <b-form-input
                      :size="size"
                      v-model="item.quantity"
                      type="number"
                      min="0"
                      class="w-50"
                      style="display: inline-block; padding: 0.375em;"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <b-col v-if="showPrice" class="text-right">
                <b-form-group>
                  <label v-if="index == 0" class="text-muted">
                    <small>{{ trans('price') }}</small>
                  </label>
                  <div class="py-2">
                    <dollar :value="item.price" format="0,000.00"></dollar>
                  </div>
                </b-form-group>
              </b-col>
              <b-col v-if="showPrice" class="text-right">
                <b-form-group>
                  <label v-if="index == 0" class="text-muted">
                    <small>{{ trans('amount') }}</small>
                  </label>
                  <div class="py-2">
                    <dollar :value="item.price * item.quantity" format="0,000.00"></dollar>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="showPrice">
              <b-col class="text-right">
                <div class="py-2">
                  <small class="text-muted mr-2">{{ trans('sub_total') }}</small>
                  <dollar :value="subtotal" format="0,000.00"></dollar>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="showAddons">
            <label class="d-block">
              <strong>{{ question.options.addons_label || trans('addons') }} {{ question.options.addons_required ? '*' : '' }}</strong>
            </label>
            <b-row v-for="(addon, index) in addons" :key="'addon-'+index">
              <b-col>
                <b-form-group class="mb-0">
                  <b-form-checkbox v-model="addon.quantity" :value="1" :unchecked-value="0" @change="onChangeAddon(addon, index)">
                    {{ addon.name }}
                    <strong v-if="addon.price > 0" class="ml-2"><dollar :value="addon.percentage ? addon.price * price / 100 : addon.price"></dollar></strong>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div v-if="showBookingAddons" class="mt-4">
            <label class="d-block">
                <strong>{{ question.options.addons_label || trans('booking_addons') }} {{ question.options.addons_required ? '*' : '' }}</strong>
              </label>
              <b-row v-for="(resource, index) in resources" :key="'addon-'+index" class="mb-2">
              <b-col class="col-4">
                <div class="py-2 text-center">
                  <img v-if="resource.image_url" :src="resource.image_url" :alt="resource.name" class="img-fluid" />
                </div>
              </b-col>
              <b-col class="col-8">
                <div class="lead mb-2">
                  <strong>{{ resource.name }}</strong>
                  <dollar class="ml-2"
                    :value="resource.price"
                  ></dollar>
                </div>
                <b-form inline @submit.prevent>
                  <b-form-group class="mb-2">
                    <b-button v-if="!added.includes(index)" variant="branded" size="sm" @click="added.push(index)">
                      <i class="fa fa-fw fa-plus"></i>
                    </b-button>
                    <div v-if="added.includes(index)" class="d-inline-block text-left">
                      <b-button variant="success" size="sm" disabled>
                        <i class="fa fa-fw fa-check"></i>
                      </b-button>
                      <b-button variant="link" size="sm" class="text-danger" @click="added.splice(added.indexOf(index), 1)">
                        <i class="fa fa-fw fa-times"></i>
                      </b-button>
                    </div>
                  </b-form-group>
                </b-form>
              </b-col>
            </b-row>
          </div>
        </div>
        <div v-if="showTickets">
          <label class="d-block">
            <strong>{{ trans('tickets') }}</strong>
          </label>
          <b-row>
            <b-col class="pr-0" v-if="showPrice">
              <b-form-group :label="trans('price')">
                <div class="py-2">
                  <dollar :value="ticketPrice" format="0,000.00"></dollar>
                </div>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label class="d-block mb-0">&nbsp;</label>
                <span>x</span>
                <b-form-input
                  :size="size"
                  v-model="tickets_quantity"
                  type="number"
                  :min="question.options.tickets_min_quantity"
                  :max="question.options.tickets_max_quantity || undefined"
                  class="w-50"
                  style="display: inline-block; padding: 0.375em;"
                />
              </b-form-group>
            </b-col>
            <b-col v-if="showPrice" class="text-right">
              <b-form-group :label="trans('sub_total')">
                <strong class="d-block py-2">
                  <dollar :value="subtotal" format="0,000.00"></dollar>
                </strong>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
      <small v-if="question.options.hidden" style="font-weight: bold;">({{ trans('visible_to_admins_only') }})</small>
      <AmClassModal
        :organization="organization"
        :cls="am_class_for_modal"
        :id="`class-modal-${am_class.id}`"
        no-delete
        no-copy
        @saved="onSaved"
        v-if="!isLive"
      ></AmClassModal>
    </div>
    <div v-if="!am_class">
      <p class="lead p-4 text-center text-danger">
        {{ trans('select_an_event') }}
      </p>
    </div>
    
  </div>
</template>
<style>
  .register-btn {
      margin-top: 5px;
      padding: 5px 15px 5px 15px;
      display: inline-block !important;
      background-color: #22b24c;
      border: 1px solid #22b24c;  
      border-radius: 5px;
      box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
      color: #FFFFFF;
      cursor: pointer;
  }
  .register-btn label {
    cursor: pointer;
  }
  .register-btn.disabled {
    background-color: #ebebeb;
    box-shadow: none;
    cursor: default;
    border: 0;
  }
  .register-btn.disabled label{
    cursor: default;
  }
  .register-btn.checked {
    box-shadow: none;
  }
  .fc.event-calendar .fc-view.fc-dayGridMonth-view.fc-dayGrid-view>.table-bordered {
    border-top: none;
  }
  .event-calendar-header {
    background-color: #f0f0f0!important;
    border: 1px solid #dee2e6;
    border-bottom: none;
  }
  .fc.event-calendar .fc-head-container,
  .fc.event-calendar .fc-head-container>.fc-row {
    border: none;
  }
  .fc.event-calendar .fc-day-header {
    background-color: #f0f0f0!important;
    padding: 1em 0;
    border: none;
    font-weight: normal;
  }
  .fc.event-calendar .fc-day-top {
    text-align: center;
    font-size: 90%;
  }
  .fc.event-calendar .fc-day {
    background-color: transparent!important;
  }
  .fc.event-calendar .fc-day-grid-event {
    cursor: pointer;
    padding: 0;
    text-align: center;
    background-color: #fff;
  }
  .fc.event-calendar .fc-day-grid-event.disabled {
    cursor: default;
    border-color: #dee2e6!important;
    color: #dee2e6!important;
  }
  .fc.event-calendar .fc-day-grid-event .fc-content {
    white-space: normal;
    text-align: left;
  }
  .event-calendar-footer {
    border: 1px solid #dee2e6;
    border-top: none;
  }
  .hidden-colors, .hidden-colors .text-success, .hidden-colors .btn-link {
    color: #F57A00 !important;
  }
  .badge.second {
    font-size: 0.75em;
    font-weight: normal;
    background-color: #cde7f2;
    border-color: #cde7f2;
    color: #004465;
    padding: 2px 5px;
    border-radius: 4px;
    white-space: nowrap;
  }
</style>

<script>
  import Dollar from './../billing/Dollar'
  import FormPersonQuestion from './FormPersonQuestion'
  import EventsSchedule from './../class/EventsSchedule2'
  import FullCalendar from '@fullcalendar/vue'
  import bootstrapPlugin from '@fullcalendar/bootstrap'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import interactionPlugin from '@fullcalendar/interaction';
  import frLocale from '@fullcalendar/core/locales/fr-ca'
  import '@fullcalendar/core/main.css'
  import DescriptionMore from './../../../common/components/DescriptionMore'
  // Note: This question is only used client forms. Therefore
  // it is not fully operational - only for demonstration when
  // designing the form.

  function has_event_passed(organization, cls, event, now)
  {
    if (!now) now = moment()
    let start = moment(event.start)
    if (cls && cls.registration_stop_minutes !== null) {
      start.add(-cls.registration_stop_minutes, 'minute')
    } else {
      start.endOf('day')
    }
    return now.isAfter(start)
  }

  function findFirstCalendarDate(question) {
    if (!question ||
      !question.am_event ||
      question.am_event.events.length == 0 ||
      !question.options.show_calendar ||
      ['single', 'multiple'].indexOf(question.options.purchase_rule) == -1)
      return moment().toISOString()

    let now = moment()
    let date = _.reduce(question.am_event.events, (date, e) => {
      if (!!question.options.purchase_rule &&
        ['single', 'multiple'].indexOf(question.options.purchase_rule) &&
        !!question.options.include_dates &&
        question.options.include_dates.indexOf(e.start) === -1)
        return date
      let d = moment(e.start)
      if (d.unix() > now.unix() &&
        (date == null || d.unix() < date.unix()))
        date = d
      return date
    }, null)

    if (date) {
      date.set('date', 15)
      return date.toISOString()
    }
    return moment().toISOString()
  }

  export default {
    props: {
      organization: Object,
      recipientForm: Object,
      schedule: Array,
      locale: window.lang,
      value: Object, // answer
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
      hideHeader: {
        type: Boolean,
        default: false,
      },
      isDesign: {
        type: Boolean,
        default: false,
      },
      hideRegButton: {
        type: Boolean,
        default: false,
      },
      proposeNames: {
        type: Boolean,
        default: false,
      },
      isLive: {
        type: Boolean,
        default: false,
      },
      isMultiClass: {
        type: Boolean,
        default: false,
      },
      invoice: {
        type: Object,
        default() {return {}},
      },
    },
    components: {
      Dollar,
      FormPersonQuestion,
      EventsSchedule,
      FullCalendar,
      DescriptionMore,
      AmClassModal: () => import('./../class/AmClassModal'),
    },
    data() {
      let coupon = null
      if (!!this.question.promo_code) coupon = this.question.promo_code.code
      let show_coupon = this.organization.id == 284 || !!coupon

      let answers = {}
      answers['participants'] = [{}]

      return {
        trans: trans,
        moment: moment,
        numeral: numeral,
        currency: _.currency,
        password: null,
        answer: null,
        guest_participants: null,
        addons: null,
        booking_addons: null,
        added: [],
        resources: null,
        pre_checked: false, // no purchase rule
        selected: [], // multiple check boxes
        chosen: null, // single radio buttons or select
        calendar_date: findFirstCalendarDate(this.question),
        calendar_locale: window.lang == 'fr' ? frLocale : undefined,
        calendar_plugins: [dayGridPlugin, bootstrapPlugin, interactionPlugin],
        show_coupon: show_coupon,
        coupon: coupon,
        morning_afternoon: null,
        tickets_quantity: this.question.options.tickets_quantity,
        upcoming: [],
        answers: answers,
        financing: this.question.options.force_installments,
        events_from_date_limit: null,
        is_registering: false,
        seconds: null,
        timerInterval: null,
        is_updating: false,
        invoice_item_id: null,
        participants: [{}],
        loaded: false,
        am_class_for_modal: null,
      }
    },
    computed: {
      regDisabled() {
        return this.question.required || this.registrationPeriodError != null || this.is_registering || (_.isNumeric(this.am_class.spots) && this.am_class.spots <= 0) || this.allPassed
      },
      allPassed() {
        return _.reduce(this.am_class.events || [], (all_passed, e) => {
          if (!has_event_passed(this.organization, this.am_class, e)) all_passed = false
          return all_passed
        }, true)
      },
      timer() {
        if (!this.invoice || !this.invoice.is_viable_cart) return null
        return _.buildCartTimer(this.seconds)
      },
      installmentString() {
        if (this.am_class.financing.custom_description) {
          return this.am_class.financing.custom_description
        }

        let nb_installments = this.am_class.financing.nb_installments
        let interval = this.am_class.financing.interval_type ?? 'month'

        if (this.am_class.financing.dynamic && this.am_class.events.length > 0) {
          let firstClass = this.am_class.events[0]
          if (firstClass.start) {
            let firstDate = moment(firstClass.start)
            nb_installments = firstDate.diff(moment(), interval == 'month' ? 'months' : 'weeks')
          }
        }
        
        if (nb_installments == 0 || !nb_installments) {
          return false
        }

        let string = trans(this.am_class.financing.initial_amount > 0 ? 'pay_in' : 'pay_in_no_deposit', {
            'nb_installments': nb_installments ?? 0,
            'now': this.currency(this.getInitialAmount(this.am_class.financing)),
            'amount': this.currency((this.startPrice - this.getInitialAmount(this.am_class.financing)) / nb_installments),
            'type':  this.am_class.financing.nb_installments > 1 ? `/ ${trans(interval).toLowerCase()}` : '',
        })

        return string
      },
      am_class() {
        return this.question.am_event
      },
      customSchedule() {
        let custom_schedule = null
        if (!!this.am_class && !!this.am_class.custom_schedule)
          custom_schedule = this.am_class.custom_schedule
        if (!!this.question.options.custom_schedule)
          custom_schedule = this.question.options.custom_schedule
        return custom_schedule
      },
      amClassEventsForSchedule() {
        if (!this.am_class) return []
        return _.reduce(this.am_class.events, (events, e) => {
          if (!!this.question.options.purchase_rule &&
            ['single', 'multiple'].indexOf(this.question.options.purchase_rule) >= 0 &&
            !!this.question.options.include_dates &&
            this.question.options.include_dates.indexOf(e.start) === -1) {
              return events
            }
           

          if (this.question.options.limit_events && this.question.options.limit_start && this.question.options.limit_end) {
            // if event date is in between 
            // its being done on the backend
            if (moment(e.start).isBetween(this.question.options.limit_start, this.question.options.limit_end)) {
              events.push(e)
            }
          } else {
            events.push(e)
          }
          this.events_from_date_limit = events;
          return events
        }, [])
      },
      passwordProtected() {
        return !!this.question.options.password
      },
      passwordUnlocked() {
        return this.passwordProtected &&
          !!this.answer &&
          this.answer.password == this.question.options.password
      },
      promo_code() {
        return this.question.promo_code
      },
      price() {
        let price = _.isNumeric(this.question.options.price) ?
          this.question.options.price :
          this.question.am_event.price
        return parseFloat(price)
      },
      registrationPeriodError() {
        let error = null

        if (this.am_class.registration_start && moment().isBefore(moment(this.am_class.registration_start))) {
          error = trans('registrations_open_at', {'date': moment(this.am_class.registration_start).format('LLL')});
        }

        if (this.am_class.registration_end && moment().isAfter(moment(this.am_class.registration_end)) && !error) {
          error = trans('registrations_ended_at', {'date': moment(this.am_class.registration_end).format('LLL')});
        }

        return error
      },
      priceForAll() {
        if (!this.question.options.purchase_rule && this.question.options.price_rule == 'price_per_date') {
          return this.price * this.upcoming.length
        }
        return this.price
      },
      proRataReduction() {
        if (!this.question.options.purchase_rule &&
          this.question.options.apply_pro_rata &&
          !!this.question.am_event &&
          this.question.am_event.events.length > 1) {
            let events = this.question.options.limit_events ? (this.events_from_date_limit || this.question.am_event.events) : this.question.am_event.events
            if (this.question.am_event.price_per_class && this.question.options.pro_rata.force_class_pro_rata) {
              this.question.options.pro_rata.type == 'amount'
              this.question.options.pro_rata.amount = this.question.am_event.price_per_class
            }
            return this.price - _.proRataPrice(this.question.options.pro_rata, this.price, events)
        }
        return 0
      },
      hasNoShowRebate() {
        return this.question.options.pro_rata && this.question.options.pro_rata.do_not_show_as_rebate
      },
      proRataReductionTitle() {
        if (this.proRataReduction > 0) {
          return trans('pro_rata_explain')
        }
        return null
      },
      startPriceBeforeReduction() {
        let price = this.price
        if (this.question.options.purchase_rule == 'morning_afternoon') {
          let price_morning = _.isNumeric(this.question.options.price_morning) ?
            this.question.options.price_morning :
            price
          if (price_morning < price) price = price_morning
          let price_afternoon = _.isNumeric(this.question.options.price_afternoon) ?
            this.question.options.price_afternoon :
            price
          if (this.morning_afternoon == 'morning') price = price_morning
          else if (this.morning_afternoon == 'afternoon') price = price_afternoon
          if (price_afternoon < price) price = price_afternoon
        }
        return price
      },
      promoCodeReduction() {
        return !!this.promo_code ? _.promoCodeReduction(this.promo_code, this.startPriceBeforeReduction) : 0
      },
      startPrice() {
        let price = this.startPriceBeforeReduction
        if (this.proRataReduction > 0) {
          price -= this.proRataReduction
        }
        else if (this.promoCodeReduction > 0) {
          price -= this.promoCodeReduction
        }
        return price
      },
      showStartingAt() {
        if (this.question.options.purchase_rule != 'morning_afternoon') return false
        let price_morning = _.isNumeric(this.question.options.price_morning) ?
          this.question.options.price_morning :
          this.price
        let price_afternoon = _.isNumeric(this.question.options.price_afternoon) ?
          this.question.options.price_afternoon :
          this.price
        return this.price != price_morning || this.price != price_afternoon
      },
      showTickets() {
        if (this.question.type != 'ticket_block') return false
        if (!this.question.options.purchase_rule) return !!this.pre_checked
        if (this.question.options.purchase_rule.indexOf('multiple') >= 0) return this.selected.length > 0
        if (this.question.options.purchase_rule.indexOf('single') >= 0) return !!this.chosen
        if (this.question.options.purchase_rule == 'morning_afternoon') return !!this.morning_afternoon
        return false
      },
      showClear() {
        if (!this.question.options.purchase_rule || this.question.required) return false
        if (this.question.options.purchase_rule.indexOf('single') >= 0 && this.chosen) return true
        if (this.question.options.purchase_rule == 'morning_afternoon' && this.morning_afternoon) return true
        return false
      },
      eventPrice() {
        let price = this.startPrice
        if (this.question.options.purchase_rule == 'morning_afternoon') {
          if (this.morning_afternoon == 'morning' &&
            _.isNumeric(this.question.options.price_morning))
            price = this.question.options.price_morning
          if (this.morning_afternoon == 'afternoon' &&
            _.isNumeric(this.question.options.price_afternoon))
            price = this.question.options.price_afternoon
          if (this.morning_afternoon == 'all_day' &&
            _.isNumeric(this.question.options.price_all_day))
            price = this.price
        }
        return price
      },
      ticketPrice() {
        if (this.question.type != 'ticket_block') return null
        if (!this.question.options.purchase_rule)
          return this.pre_checked ? this.priceForAll : 0
        if (this.question.options.purchase_rule.indexOf('multiple') >= 0) {
          let count = this.selected.length
          if (this.question.options.price_rule == 'price_for_class') count = 1
          return this.price * count
        }
        if (this.question.options.purchase_rule.indexOf('single') >= 0)
          return this.chosen ? this.price : 0
        if (this.question.options.purchase_rule == 'morning_afternoon') {
          if (!this.morning_afternoon) return 0
          if (this.morning_afternoon == 'morning' &&
            _.isNumeric(this.question.options.price_morning))
            return this.question.options.price_morning
          if (this.morning_afternoon == 'afternoon' &&
            _.isNumeric(this.question.options.price_afternoon))
            return this.question.options.price_afternoon
          if (this.morning_afternoon == 'all_day' &&
            _.isNumeric(this.question.options.price_all_day))
            return this.price
        }
        return this.price
      },
      showPrice() {
        return this.question.options.show_price !== false
      },
      show_participant() {
        if (this.question.type == 'ticket_block') return false
        return this.question.options.show_participant === false ? false : true
      },
      isFree() {
        return this.price == 0
      },
      days() {
        return _.reduce(this.question.am_event.events, (days, e) => {
          if (!!this.question.options.purchase_rule &&
            ['single', 'multiple'].indexOf(this.question.options.purchase_rule) >= 0 &&
            !!this.question.options.include_dates &&
            this.question.options.include_dates.indexOf(e.start) === -1)
            return days
          let day = moment(e.start).format('YYYY-MM-DD')
          if (days.indexOf(day) === -1) days.push(day)
          return days
        }, [])
      },
      hasMaximumAttendance() {
        return _.isNumeric(this.question.options.number_of_spots) || _.isNumeric(this.am_class.maximum_attendance)
      },
      showNumberOfSpots() {
        return this.question.options.show_number_of_spots === undefined ||
          this.question.options.show_number_of_spots
      },
      dateOptions() {
        let day_of_the_week = ['single_recurring', 'multiple_recurring'].indexOf(this.question.options.purchase_rule) >= 0
        let events = day_of_the_week ?
          this.question.am_event.future_recurring_events_of_the_week :
          this.question.am_event.events
        let hide_times = this.question.options.hide_times || false
        if (this.isOneDayMultipleTimes) hide_times = false
        let futureCount = 0
        return _.reduce(events, (options, e) => {
          let isDisabled = !moment().startOf('day').isBefore(e.start)
          if (!!this.question.options.purchase_rule &&
            ['single', 'multiple'].indexOf(this.question.options.purchase_rule) >= 0 &&
            !!this.question.options.include_dates &&
            this.question.options.include_dates.indexOf(e.start) === -1)
            return options
          if (['single', 'multiple'].indexOf(this.question.options.purchase_rule) >= 0 &&
            _.isNumber(this.question.options.limit_next_events_count) &&
            !isDisabled) {
            if (futureCount >= this.question.options.limit_next_events_count) {
              isDisabled = true
            }
            futureCount += 1
          }
          if (['single', 'multiple'].indexOf(this.question.options.purchase_rule) >= 0 &&
            _.isNumber(this.question.options.stop_sell_before) &&
            !isDisabled) {
            if (moment(e.start).isSameOrBefore(moment().add(this.question.options.stop_sell_before, this.question.options.stop_sell_before_units))) {
              isDisabled = true
            }
            futureCount += 1
          }
          if (['single', 'multiple'].indexOf(this.question.options.purchase_rule) >= 0 &&
          this.question.options.limit_days_advance &&
            !isDisabled) {
            let afterDate = moment().add(this.question.options.limit_days_advance, 'days')
            if (this.question.options.start_sell_minutes_of_day) {
              let openTime = moment().startOf('day').add(this.question.options.start_sell_minutes_of_day, 'minutes')
              if (moment().isBefore(openTime)) {
                afterDate.add(-1, 'days')
              } else {
                // set afterDate to the whole day
                afterDate = afterDate.endOf('day')
              }
            }
   
            if (moment(e.start).isAfter(afterDate)) {
              isDisabled = true
            }
            futureCount += 1
          }
          let nbSpots = e.extendedProps && e.extendedProps.number_of_spots ? e.extendedProps.number_of_spots : ''
          let spots_text = this.hasMaximumAttendance && this.showNumberOfSpots ? ` (${nbSpots} ${trans('remaining_spots').toLowerCase()})` : ''
          if (e.name) spots_text += ` - ${e.name}`
          let prefix = this.days.length > 1 ? moment(e.start).format('dddd') : ''
          if (!!prefix) {
            if (day_of_the_week) {
              if (window.lang == 'fr') prefix = 'Les ' + prefix
              prefix += 's, ' + trans('starting_on').toLowerCase() + ' '
            } else {
              prefix += ', '
            }
          }
          options.push({
            value: moment(e.start).toISOString(),
            text: prefix + moment(e.start).format(this.days.length > 1 ? (hide_times ? 'LL' : 'LLL') : (hide_times ? 'LL' : 'LT')) + spots_text,
            title: moment(e.start).format('LT') + spots_text,
            start: e.start,
            end: e.end,
            disabled: isDisabled,
            id: e.id,
          })
          return options
        }, [])
      },
      futureDateOptions() {
        return _.reduce(this.dateOptions, (future, o) => {
          if (!o.disabled) future.push(o)
          return future
        }, [])
      },
      morningAfternoonOptions() {
        let save = (this.question.options.price_morning || this.price) +
          (this.question.options.price_afternoon || this.price) -
          (this.question.options.price || this.price)
        return _.compact([
          {
            value: 'morning',
            text: this.question.am_event.upcoming_morning_events.length + ' ' +
              (this.question.options.label_morning || (trans('morning' + (this.question.am_event.upcoming_morning_events.length > 1 ? 's' : '')).toLowerCase() + ' ' + trans('only').toLowerCase())) + ' ' +
              (this.showPrice ? (' ' + _.currency(this.question.options.price_morning || this.price)) : '')
          },
          !this.question.options.afternoon_not_allowed ? {
            value: 'afternoon',
            text: this.question.am_event.upcoming_afternoon_events.length + ' ' +
              (this.question.options.label_afternoon ||
                (trans('afternoon' + (this.question.am_event.upcoming_afternoon_events.length > 1 ? 's' : '')).toLowerCase() +
              ' ' + trans('only').toLowerCase())) + ' ' +
              (this.showPrice ? (' ' + _.currency(this.question.options.price_afternoon || this.price)) : '')
          } : null,
          {
            value: 'all_day',
            text: this.days.length + ' ' +
              (this.question.options.label_all_day || (trans('full_day' + (this.days.length > 1 ? 's' : '')).toLowerCase())) +
              (this.showPrice ? (' ' + _.currency(this.question.options.price || this.price)) : '') +
              (!this.question.options.afternoon_not_allowed ? (save > 0 ? ` (${trans('save_money').toLowerCase()} ${_.currency(save)})` : '') : '')
          },
        ])
      },
      isOneDayMultipleTimes() {
        if (!this.question || !this.question.am_event) return false
        let result = _.reduce(this.question.am_event.events, (result, e) => {
          if (!!this.question.options.purchase_rule &&
            ['single', 'multiple'].indexOf(this.question.options.purchase_rule) >= 0 &&
            !!this.question.options.include_dates &&
            this.question.options.include_dates.indexOf(e.start) === -1)
            return result
          if (this.question.options.purchase_rule == 'single' &&
            _.isNumber(this.question.options.limit_next_events_count) &&
            result.days.length >= this.question.options.limit_next_events_count)
            return result
          let day = moment(e.start).format('YYYY-MM-DD')
          if (result.days.indexOf(day) === -1) result.days.push(day)
          let time = moment(e.start).format('HH:mm:ss')
          if (result.times.indexOf(time) === -1) result.times.push(time)
          return result
        }, {days: [], times: []})
        return result.days.length == 1 && result.times.length > 1
      },
      showCalendar() {
        return ['single', 'multiple'].indexOf(this.question.options.purchase_rule) >= 0 &&
          this.question.options.show_calendar
      },
      calendarDate() {
        return this.futureDateOptions && this.futureDateOptions.length > 0 ?
          this.futureDateOptions[0].start :
          null
      },
      calendarEvents() {
        return _.map(this.dateOptions, o => {
          return {
            id: o.value,
            title: o.title,
            start: o.start,
            end: o.end,
            disabled: o.disabled,
          }
        })
      },
      purchase_rule() {
        return this.question.options.purchase_rule || null
      },
      participant_question() {
        if (this.question.type == 'ticket_block') return null
        let options = this.question.options.participant
        return {
          slug: `${this.question.slug}[${options.multiple ? `participants` : `participant`}]`,
          type: 'participant',
          label: trans('participant' + (options.multiple ? 's' : '')),
          description: null,
          required: options.name == 'required',
          options: _.assign({
            name: null,
            email: null,
            mobile: null,
            gender: null,
            gender_label: null,
            date_of_birth: null,
            age_constraint: null,
            other_phone: null,
            other_phone_label: null,
            address: null,
            zip_postal_code: null,
            multiple: options.multiple,
            addons: this.question.options.show_addons && !!this.addons && this.addons.length > 0 ? this.addons : null,
            addons_required: this.question.options.addons_required,
            addons_label: this.question.options.addons_label,
            booking_addons: this.question.options.show_booking_addons && !!this.booking_addons && this.booking_addons.length > 0 ? this.booking_addons : null,
          }, options || {}),
        }
      },
      showGuestParticipants() {
        return !!this.guest_participants &&
          this.guest_participants.length > 0
      },
      subtotal() {
        if (this.question.type == 'ticket_block') {
          return this.ticketPrice * this.tickets_quantity
        }

        let price = this.eventPrice
        if (!this.question.options.purchase_rule && this.question.options.price_rule == 'price_per_date')
          price = this.priceForAll
        else if (this.question.options.purchase_rule == 'multiple' && this.question.options.price_rule == 'price_per_date')
          price = this.price * this.selected.length

        if (this.showGuestParticipants) {
          price += _.reduce(this.guest_participants, (sum, p) => {
            sum += p.price * p.quantity
            return sum
          }, 0)
        }

        return price
      },
      showAddons() {
        return this.question.options.show_addons &&
          !!this.addons &&
          this.addons.length > 0 && !this.question.options.show_participant
      },
      showBookingAddons() {
        return this.question.options.show_booking_addons && 
          (!!this.question.options.booking_addons && 
          this.question.options.booking_addons.length > 0) ||           
          (!!this.booking_addons && 
          this.booking_addons.length > 0) && !this.question.options.show_participant
      }
    },
    watch: {
      question() {
        this.init()
      },
      selected() {
        if (!!this.guest_participants) {
          _.each(this.guest_participants, (p, i) => {
            let price = this.question.options.guest_participants[i].price
            if (!this.question.options.purchase_rule && this.question.options.price_rule == 'price_per_date' && this.upcoming.length > 0)
              price *= this.upcoming.length
            else if (this.question.options.purchase_rule == 'multiple' && this.question.options.price_rule == 'price_per_date' && this.selected.length > 0)
              price *= this.selected.length
            p.price = price
          })
        }
        if (this.selected.length > 0) {
          if (!this.is_registering && !this.is_updating && this.loaded) {
            this.registerToClass(true)
          }
        }
      },
      chosen() {
        if (!this.is_registering && !this.is_updating && this.loaded) {
          this.registerToClass(true)
        }
      },
      answers: {
        handler() {
          this.$emit('input', this.answers)
          if (!this.is_registering && !this.is_updating && this.loaded) {
            this.registerToClass(true)
          }
        },
        deep: true
      },
      invoice() {
        this.checkDataOnInvoice()
        this.updateTimer()
      }
    },
    methods: {
      onOneDateChange() {

      },
      onSaved(am_class) {
        this.question.am_event = am_class
      },
      editClass() {
        this.am_class_for_modal = this.am_class
        this.$bvModal.show(`class-modal-${this.am_class.id}`)
      },
      onRemoveParticipant(index) {
        this.participants.splice(index, 1)
      },
      addParticipant() {
        this.participants.push({})
      },
      participantQuestionWithIndex(index) {
        let pQuestion = _.cloneDeep(this.participant_question)
        pQuestion.slug = `${this.question.slug}[participants][${index}]`
        pQuestion.label = null
        return pQuestion
      },
      updateTimer() {
        this.seconds = this.invoice.status == 'expired' ? 0 : moment(this.invoice.expired_at).diff(moment(), 'seconds')
        if (this.seconds == 0 && this.timerInterval) {
          this.clearTimer()
        } else if (this.seconds > 0 && !this.timerInterval) {
          this.timerInterval = setInterval(this.updateTimer, 1000)
        }
      },
      clearTimer() {
        if (this.timerInterval) clearInterval(this.timerInterval)
        this.timerInterval = null
        this.pre_checked = false
      },
      unRegisterFromClass() {
        this.is_updating = true
        this.is_registering = true
        axios.delete(`/org/${this.organization.id}/cart/class/${this.invoice_item_id}`).then(response => {
          this.$emit('invoice', response.data)
          this.is_updating = false
          this.is_registering = false
        }).catch(error => {
          if (error.response && error.response.data && error.response.data.message) {
            this.$bvToast.toast(error.response.data.message, {
              title: this.trans('error'),
              variant: 'danger',
              autoHideDelay: 5000,
            })
          }
          this.is_registering = false
          this.is_updating = false
        })
      },
      registerToClass(silent) {
        if (!this.isLive) {
          return
        }
        
        // serilizing the form
        let form = document.getElementById('form');
        var formData = new FormData(form);
        //let structuredData = this.formDataToNestedObject(formData);
        // can be better!!!
        formData.append('class_id', this.am_class.id);
        formData.append('form_id', this.recipientForm.form_id,);
        formData.append('question_id', this.question.id);
        formData.append('event_ids', this.selected);

        if (!silent) {
          this.is_registering = true
        }
        this.is_updating = true

        axios.post(`/org/${this.organization.id}/cart/class`, formData).then(response => {
          let invoice = response.data
          this.$emit('invoice', response.data)
          let action = form.action
          if (!action.includes('/form')) {
            form.action = `${action}/${invoice.ucid}/form`
          }
          this.$emit('formAction', form.action)
          this.is_registering = false
          this.is_updating = false
          this.updateTimer()
          let expirationMsg = document.getElementById('expiration');
          if (expirationMsg) {
            expirationMsg.style.display = 'none';
          }
          // get continue btn by class submit-btn-form
          let continueBtn = document.querySelector('.submit-btn-form');
          if (continueBtn) {
            continueBtn.removeAttribute('disabled');
          }
        }).catch(error => {
          if (error.response && error.response.data && error.response.data.message) {
            this.$bvToast.toast(error.response.data.message, {
              title: this.trans('error'),
              variant: 'danger',
              autoHideDelay: 5000,
            })
          }
          this.is_registering = false
          this.is_updating = false
        })
      },
      onRegisterChange() {
        if (!this.isLive) {
          return
        }
        this.pre_checked = !this.pre_checked
        if (!this.pre_checked) {
          this.registerToClass()
        } else {
          this.unRegisterFromClass()
        }
      },
      registrationOnClick() {
        //this.pre_checked = !this.pre_checked
      },
      getLocationProperty(property, locationId) {
        if (this.booking_addons) {
          const location = _.find(this.booking_addons, { id: locationId });
          return location ? location[property] : '';
        }
        return '';
      },
      getInitialAmount(item) {
        return item.installment_type == 'amount' ? item.initial_amount : this.startPrice * item.initial_amount / 100
      },
      onKeydownPassword(e) {
        if (e.keyCode == 13) this.onApplyPassword()
      },
      onApplyPassword() {
        if (this.password == this.question.options.password) {
          if (!this.answer) this.answer = {}
          this.$set(this.answer, 'password', this.password)
        }
      },
      deserializeAdditionalParticipants() {
        return !!this.question.options.guest_participants &&
          this.question.options.guest_participants.length > 0 ?
          _.map(this.question.options.guest_participants, p => {
            let price = p.price
            if (!this.question.options.purchase_rule && this.question.options.price_rule == 'price_per_date' && this.upcoming.length > 0)
              price *= this.upcoming.length
            else if (this.question.options.purchase_rule == 'multiple' && this.question.options.price_rule == 'price_per_date' && this.selected.length > 0)
              price *= this.selected.length
            return {
              label: p.label,
              quantity: 0,
              price: price
            }
          }) :
          null
      },
      deserializeAddons() {
        return this.question.options.show_addons &&
          !!this.question.options.addons &&
          this.question.options.addons.length > 0 ?
          _.map(this.question.options.addons, addon => {
            let price = addon.price
            return {
              name: addon.name,
              quantity: 0,
              price: price,
              percentage: addon.percentage
            }
          }) :
          null
      },
      deserializeBookingAddons() {
        return this.question.options.show_booking_addons &&
          !!this.question.options.booking_addons &&
          this.question.options.booking_addons.length > 0 ?
          _.map(this.question.options.booking_addons, addon => {
            return {
              name: addon.name,
              quantity: 0,
              price: addon.price,
              location_ids: addon.location_ids,
              image_url: addon.image_url,
            }
          }) :
          null
      },
      init() {
        this.pre_checked = this.question.required
        this.guest_participants = this.question.type == 'event_block' ?
          this.deserializeAdditionalParticipants() :
          null
        this.addons = this.question.type == 'event_block' && this.question.options.show_addons ?
          this.deserializeAddons() :
          null
        this.resources = this.question.type == 'event_block' && this.question.options.show_booking_addons ?
          this.deserializeBookingAddons() :
          null
        this.onSelectOrClearAll(false)
        this.calendar_date = findFirstCalendarDate(this.question)
        if (this.question.type == 'ticket_block') {
          if (this.tickets_quantity < this.question.options.tickets_min_quantity)
            this.tickets_quantity = this.question.options.tickets_min_quantity
          if (this.question.options.tickets_max_quantity > 0 &&
            this.tickets_quantity > this.question.options.tickets_max_quantity)
            this.tickets_quantity = this.question.options.tickets_max_quantity
        }
        this.coupon = !!this.question.promo_code ? this.question.promo_code.code : null
        this.show_coupon = this.organization.id == 284 || !!this.coupon
        this.password = null
        this.financing = this.question.options.force_installments
        this.checkDataOnInvoice()
      },
      checkDataOnInvoice() {
        let found = false
        
        if (this.invoice.status == 'expired') {
          this.loaded = true
          return
        }

        _.each(this.invoice.invoice_items || [], ii => {
          if (ii.form_answer?.json?.events_slug 
          && `${ii.form_answer.json.events_slug}_event_block${ii.form_answer.json.am_class_id}` == this.question.slug) {
            this.pre_checked = true
            this.invoice_item_id = ii.id
            
            if (!this.loaded) {
              this.answers = ii.form_answer.json // could be much better - boucle infinie...
              console.log(this.answers)
              this.$nextTick(() => {
                this.loaded = true
              })

              if (ii.form_answer?.json?.purchase_rule) {
                if (ii.form_answer.json.dates && ii.form_answer.json.dates.length > 0) {
                  if (ii.form_answer.json.purchase_rule == 'multiple') {
                    this.selected = ii.form_answer.json.dates
                  } else {
                    this.chosen = ii.form_answer.json.dates[0]
                  }
                }
              }

              this.updateTimer()
            }

            found = true
          }
        })
        
        if (!found) {
          this.pre_checked = false
          if (this.invoice && this.invoice?.invoice_items?.length == 0) {
            this.loaded = true
          }
        }
      },
      onChangeAddon(addon, index) {
        _.each(addon.addons, addon => {
          if (addon.quantity == 0) addon.quantity = 0
          addon.disabled = addon.quantity == 0
        })
      },
      onClickClear() {
        if (this.question.options.purchase_rule.indexOf('single') >= 0) this.chosen = null
        if (this.question.options.purchase_rule == 'morning_afternoon') this.morning_afternoon = null
      },
      onClickPrevMonth() {
        this.calendar_date = moment(this.calendar_date).add(-1, 'month').toISOString()
        this.$refs.calendar.getApi().prev()
      },
      onClickNextMonth() {
        this.calendar_date = moment(this.calendar_date).add(1, 'month').toISOString()
        this.$refs.calendar.getApi().next()
      },
      onEventRender(info) {
        info.el.style.color = this.organization.button_color
        info.el.style.borderColor = this.organization.button_color
        info.el.style.borderWidth = '1px'
        info.el.dataset.event_id = info.event.id
        info.el.querySelector('.fc-time').style.display = 'none'
        if (info.event.extendedProps.disabled)
          info.el.className += ' disabled'
        if (this.selected.indexOf(info.event.id) >= 0) {
          info.el.style.color = '#ffffff'
          info.el.style.backgroundColor = this.organization.button_color
        }
      },
      onEventClick(e) {
        if (e.event.extendedProps.disabled) return
        const index = this.selected.indexOf(e.event.id)
        if (index >= 0) {
          this.selected.splice(index, 1)
          e.el.style.color = this.organization.button_color
          e.el.style.backgroundColor = 'transparent'
        } else {
          if (this.purchase_rule == 'single') {
            if (this.selected) this.onSelectOrClearAll(false)
            this.selected = [e.event.id]
          } else {
            this.selected.push(e.event.id)
          }
          e.el.style.color = '#ffffff'
          e.el.style.backgroundColor = this.organization.button_color
        }
      },
      onSelectOrClearAll(check) {
        if (!check) {
          this.selected = []
          if (this.$refs.calendar) {
            this.$refs.calendar.$el.querySelectorAll(`a.fc-day-grid-event.fc-event[data-event_id`).forEach(el => {
                el.style.color = this.organization.button_color
                el.style.backgroundColor = 'transparent'
            })
          }
        } else {
          let day_of_the_week = ['single_recurring', 'multiple_recurring'].indexOf(this.question.options.purchase_rule) >= 0
          let events = day_of_the_week ?
            this.question.am_event.future_recurring_events_of_the_week :
            this.question.am_event.events
          this.selected = _.map(events, 'id')
        }
      },
      buildResources() {
          const resources = [];
          if (this.question.options.booking_addons) {
            this.question.options.booking_addons.forEach(resource => {
              const name = resource.name || this.getLocationProperty('name', resource.location_id);
              const image_url = resource.image_url || this.getLocationProperty('image_url', resource.location_id);
              
              resources.push({
                name: name,
                price: resource.price,
                tax_ids: resource.tax_ids,
                gl_id: resource.gl_id,
                image_url: image_url,
              });
            });
          }

          return resources;
      },
      loadLocationsAndBuildResources() {
          let ids = _.compact(_.map(this.question.options.booking_addons || [], 'location_id'))
          if (ids.length == 0 ||
            this.booking_addons &&
            this.booking_addons.length == ids.length &&
            _.xor(this.ids, _.map(this.booking_addons, 'id')).length == 0) 
          {
            this.resources = this.buildResources();
            return;
          }

          this.busy = true
          this.error = null
          let url = `/organization/${this.organization.id}/location/get_by_ids`
          axios.post(url, {ids: ids})
          .then(response => {
            this.busy = false
            this.booking_addons = response.data
            this.resources = this.buildResources();
          })
          .catch(error => {
            this.busy = false
            this.booking_addons = []
            this.error = _.errorFromAjax(error)
          })
        },
    },
    mounted() {
      window['questionEventBlock' + (this.question && this.question.id ? this.question.id : '')] = this
      this.$nextTick(() => {
        this.init()
      })
    },
  }
</script>
